import { render, staticRenderFns } from "./familleActions.vue?vue&type=template&id=75d46680"
import script from "./familleActions.vue?vue&type=script&lang=js"
export * from "./familleActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports